import React, {useState} from 'react'
import {
  Logo,
  Title,
  Form,
  Input,
  Layout,
  Button,
  Content,
  Feedback,
  Subtitle,
  Picture,
  LogoWrapper,
  Productcontent,
} from './Page.styles'

import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

type UserSubmitForm = {
  email: string;
};

const Page = () => {
  const [show, setShow]=useState(false)

  const handleClick=()=>{
    setShow(!show);
    
  }

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required('Email is required')
      .email('please provide a valid email'),
    });

    const {
      register,
      handleSubmit,
      formState: { errors }
    } = useForm<UserSubmitForm>({
      resolver: yupResolver(validationSchema)
    });

    const onSubmit = (data: UserSubmitForm) => {
      console.log(JSON.stringify(data, null, 2));
    };

    
    

  return (
    <Layout>
        <Productcontent>
       
          <LogoWrapper>
            <Logo src="../image/logo.svg" alt="logo"/>
          </LogoWrapper>
          <Content>

              <Title>We're <b> coming soon</b></Title>
              <Subtitle>
                Hello fellow shoppers! We're currently building our new fashion store.
                Add your email below to stay up-to-date with announcements and our launch
                deals. 
              </Subtitle>
              
              <Form onSubmit={handleSubmit(onSubmit)}>
                  <Input
                    id="email"
                    placeholder='Email address'
                    type="text"
                    {...register('email')}
                    className={`form-control ${errors.email ? `` : ''}`}
                    />
                    {show ? <img src='../image/icon-error.svg' alt='button icon' className='error-icon'/>: null}
                
                  <Button type="submit" onClick={handleClick} >
                    <img src='../image/icon-arrow.svg' alt='button icon'/>
                  </Button>
              </Form>
              <Feedback>{errors.email?.message}</Feedback>
            </Content> 
          </Productcontent>
        
        <Picture>
        <picture>
          <source src="../image/hero-mobile.jpg" media="(max-width: 650px)"/>
              <img src="../image/hero-desktop.jpg" alt="" className='productImage'/>
          </picture>
          </Picture>
    </Layout>
  )
}

export default Page
